export default __webpack_public_path__ + "static/media/A Tik Tok fad I regret I participated in.f57bc096.mp4";